import { getQuery } from "../../utils/helpers";
import ar from "./ar.json";
import en from "./en.json";

export const locale = getQuery().get("lang");
export const localeData = locale === "en" ? en : ar;
